// =========================================================
// js/sidebar-left.js - V10.4 (Super-Admin & Dark Mode Ready)
// =========================================================
window.renderSidebar = function() {
    const u = window.currentUser;
    if (!u) return '';
    const initials = (u.firstName?.[0] || '') + (u.lastName?.[0] || '');
    // =====================================================
    // DYNAMISCHE MENÜ-WEICHE
    // =====================================================
    let menuItems = [];
    if (u.role === 'SUPERADMIN') // Menü für den System-Master
    menuItems = [
        {
            id: 'superadmin',
            label: 'Global Ranking',
            icon: 'globe'
        },
        {
            id: 'superadmin_stats',
            label: 'System-Stats',
            icon: 'bar-chart-3'
        }
    ];
    else // Standard-Menü für Firmenmitarbeiter
    menuItems = [
        {
            id: 'dashboard',
            label: 'Dashboard',
            icon: 'layout-dashboard'
        },
        {
            id: 'calendar',
            label: 'Kalender',
            icon: 'calendar-days'
        }
    ];
    const navLinks = menuItems.map((item)=>`
        <button onclick="window.changeView('${item.id}')" 
            class="w-full flex items-center gap-4 p-3 rounded-xl transition-all duration-200 
            ${window.activeView === item.id ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400' : 'text-slate-500 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 hover:text-slate-900 dark:hover:text-slate-100'}">
            <i data-lucide="${item.icon}" class="w-5 h-5 shrink-0"></i>
            <span class="${!window.isSidebarOpen ? 'hidden' : 'block'} font-bold whitespace-nowrap">${item.label}</span>
        </button>
    `).join('');
    return `
        <aside class="${window.isSidebarOpen ? 'w-64' : 'w-20'} bg-white dark:bg-slate-900 border-r border-slate-200 dark:border-slate-800 transition-all duration-300 flex flex-col sticky top-0 h-screen z-50 shrink-0">
            
            <div class="p-6 mb-2 flex justify-between items-center">
                <div class="${!window.isSidebarOpen ? 'hidden' : 'block'} text-blue-600 dark:text-blue-400">
                    <i data-lucide="layers" class="w-8 h-8"></i>
                </div>
                <button onclick="window.toggleSidebar()" class="p-2 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg text-slate-400 dark:text-slate-500 transition-colors mx-auto ${window.isSidebarOpen ? 'mx-0' : ''}">
                    <i data-lucide="${window.isSidebarOpen ? 'panel-left-close' : 'panel-left'}" class="w-5 h-5"></i>
                </button>
            </div>
            
            ${u.role === 'SUPERADMIN' && window.isSidebarOpen ? `
                <div class="px-6 mb-4">
                    <div class="bg-rose-500/10 border border-rose-500/20 rounded-lg p-2 text-center">
                        <span class="text-[8px] font-black text-rose-500 uppercase tracking-widest">Master Access</span>
                    </div>
                </div>
            ` : ''}

            <nav class="px-4 space-y-2">
                ${navLinks}
            </nav>

            <div class="flex-1 overflow-y-auto no-scrollbar"></div>

            <div class="p-4 border-t border-slate-100 dark:border-slate-800 mt-auto space-y-2">
                
                <div onclick="window.changeView('settings')" title="Einstellungen" 
                    class="flex items-center gap-3 p-2 rounded-xl cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800 transition group">
                    
                    <div class="w-10 h-10 bg-blue-600 dark:bg-blue-700 rounded-full flex items-center justify-center text-white font-bold shrink-0 shadow-sm group-hover:ring-2 group-hover:ring-blue-100 dark:group-hover:ring-blue-900">
                        ${initials || '<i data-lucide="user" class="w-4 h-4"></i>'}
                    </div>
                    
                    <div class="${!window.isSidebarOpen ? 'hidden' : 'block'} overflow-hidden">
                        <p class="text-sm font-bold text-slate-700 dark:text-slate-200 truncate leading-tight">
                            ${u.firstName || 'System'} ${u.lastName || 'Admin'}
                        </p>
                        <p class="text-[10px] text-slate-400 dark:text-slate-500 truncate">${u.email || 'Settings'}</p>
                    </div>
                </div>

                <button onclick="window.logoutUser()" title="Abmelden" 
                    class="w-full flex items-center gap-4 p-3 rounded-xl transition-all duration-200 text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/30 hover:text-rose-700 dark:hover:text-rose-400">
                    <i data-lucide="log-out" class="w-5 h-5 shrink-0"></i>
                    <span class="${!window.isSidebarOpen ? 'hidden' : 'block'} font-bold whitespace-nowrap">Abmelden</span>
                </button>
            </div>
        </aside>
    `;
};

//# sourceMappingURL=frontend.91cf4c63.js.map
